import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAccountSettingsStore = defineStore('accountSettings', () => {
  // Strict role list and helpers
  const VALID_ROLES = new Set([
    'company_user',
    'company_admin',
    'company_suadmin',
    'company_owner',
    'client_user',
    'client_manager',
    'client_admin',
  ])

  const normalizeRole = (value: string): string => String(value || '').trim().toLowerCase()
  const deriveIsClient = (role: string): boolean => role.startsWith('client_')

  const accountId = ref('')
  const isClientUser = ref(false)
  const sessionToken = ref('')
  const role = ref('')
  const accountSettings = ref<IAccountSettings | null>(null)
  const productSettings = ref<IProductSettings | null>(null)

  const setAccountSettings = (settings: IAccountSettings | null) => {
    // Set Account ID
    setAccountId(settings?.juid ?? '')

    // Store settings
    accountSettings.value = settings
  }

  const setIsClientUser = (value: boolean) => {
    isClientUser.value = value
  }

  const setSessionToken = (token: string) => {
    sessionToken.value = token
  }

  const setRole = (userRole: string) => {
    const parsed = normalizeRole(userRole)
    const finalRole = VALID_ROLES.has(parsed) ? parsed : 'client_user'
    role.value = finalRole
    // Keep legacy flag in sync based on strict role mapping
    isClientUser.value = deriveIsClient(finalRole)
  }

  const getAccountSettings = (): any => {
    return accountSettings.value
  }

  const setAccountId = (newAccountId: string) => {
    accountId.value = newAccountId
  }

  const setProductSettings = (newProductSettings: IProductSettings | null) => {
    productSettings.value = newProductSettings
  }

  return {
    accountId,
    isClientUser,
    sessionToken,
    role,
    productSettings,

    getAccountSettings,
    setAccountSettings,
    setIsClientUser,
    setSessionToken,
    setRole,
    setProductSettings,
  }
})
